import { useState } from 'react'
import { Modal, ActionIcon, Tooltip, Button } from '@mantine/core'
import { Mail01, LinkExternal01 } from '@untitled-ui/icons-react'

import GorgiasConversation from '@/components/gorgias/GorgiasConversation'

export default function ServiceCaseGorgias({ serviceCase }) {
    const [isOpen, setIsOpen] = useState(false)
    const ticket = serviceCase.gorgias_ticket

    if (!ticket || !ticket.messages?.length) return null

    const gorgiasUrl = `https://balticwatches.gorgias.com/app/ticket/${ticket.id}`

    return (
        <>
            <Tooltip label="Conversation Gorgias">
                <ActionIcon variant="default" size={36} onClick={() => setIsOpen(true)}>
                    <Mail01 width={16} height={16} />
                </ActionIcon>
            </Tooltip>

            <Modal
                opened={isOpen}
                onClose={() => setIsOpen(false)}
                centered
                title={
                    <div className="flex items-center gap-3">
                        <span>{ticket.subject || 'Ticket Gorgias'}</span>
                        <Tooltip label="Ouvrir dans Gorgias">
                            <ActionIcon
                                variant="default"
                                component="a"
                                href={gorgiasUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <LinkExternal01 width={16} height={16} />
                            </ActionIcon>
                        </Tooltip>
                    </div>
                }
                size="xl"
            >
                <div className="flex flex-col gap-5">
                    <GorgiasConversation
                        messages={ticket.messages}
                        ai={{
                            abstract: ticket.ai_abstract_fr,
                            sentiment: ticket.ai_sentiment,
                            frustration: ticket.ai_frustration,
                            satisfaction: ticket.ai_satisfaction,
                            resolution: ticket.ai_resolution,
                        }}
                        mode="html"
                    />

                    <div className="flex justify-center pt-1">
                        <Button
                            component="a"
                            href={gorgiasUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            variant="default"
                            leftSection={<LinkExternal01 width={16} height={16} />}
                        >
                            Répondre sur Gorgias
                        </Button>
                    </div>
                </div>
            </Modal>
        </>
    )
}
